import Main from '@/layouts/Main.vue'
import SOS from '../views/SOS.vue'
import PairLifePass from '../views/PairLifePass.vue'
import LightsMeaning from '../views/LightsMeaning.vue'
import FAQ from '../views/FAQ.vue'
 
const routes = [
    {
        path: '/',
        component: Main,
        children: [
            {
                path: '/sos',
                name: 'SOS',
                component: SOS,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/how-to-pair-lifepass',
                name: 'PairLifePass',
                component: PairLifePass,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/indicator-lights-meaning',
                name: 'LightsMeaning',
                component: LightsMeaning,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/faq',
                name: 'FAQ',
                component: FAQ,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    }
]

export default routes